const tasks = {
  addSubtask: 'Ajouter une sous-tâche',
  addTimeEntry: 'Ajouter une entrée de temps',
  editTimeEntry: 'Modifier une entrée de temps',
  allTasks: 'Toutes les tâches',
  archivedTasks: 'Tâches archivées',
  cancelledTasks: 'Tâches annulées',
  completeTasks: 'Tâches complétées',
  createASection: 'Créer une section',
  createATask: 'Créer une tâche',
  estimatedCompletionTime: 'Temps de complétion estimé',
  incompleteTasks: 'Tâches non complétées',
  noTasksToDisplay: 'Aucune tâche à afficher',
  noTimeEntries: 'Aucune entrée de temps',
  parentTask: 'Tâche parente',
  subtasks: 'Sous-tâches',
  task: 'Tâche',
  taskCreated: 'Tâche créée',
  taskDeleted: 'Tâche supprimée',
  taskHistoryAssigneeCleared: 'Responsable retiré',
  taskHistoryAssigneeSet: 'Responsable défini sur {{assignee}}',
  taskHistoryDueDateCleared: 'Date d\'échéance supprimée',
  taskHistoryImportanceCleared: 'Importance retirée',
  taskHistoryImportanceSet: 'Importance définie sur {{importance}}',
  taskHistoryDueDateSet: 'Date d\'échéance définie au {{date}}',
  taskHistoryStartDateCleared: 'Date de début supprimée',
  taskHistoryStartDateSet: 'Date de début définie au {{date}}',
  taskHistoryProjectsAssigned_one: 'Assignée au projet {{projects}}',
  taskHistoryProjectsAssigned_other: 'Assignée aux projets {{projects}}',
  taskHistoryProjectsUnassigned_one: 'Retirée du projet {{projects}}',
  taskHistoryProjectsUnassigned_other: 'Retirée des projets {{projects}}',
  taskHistoryTimeLeftCleared: 'Temps restant effacé',
  taskHistoryTimeLeftSet: 'Temps restant défini à {{hours}}',
  taskHistoryTimeLogged: '{{user}} a enregistré {{hours}} le {{date}}',
  taskHistoryTimeLoggedRange: '{{user}} a enregistré {{hours}} du {{start}} au {{end}}',
  taskHistoryTimeRemoved: '{{user}} a retiré {{hours}} enregistrées le {{date}}',
  taskHistoryTimeRemovedRange: '{{user}} a retiré {{hours}} enregistrées du {{start}} au {{end}}',
  tasks: 'Tâches',
  tasksDueForThisWeek: 'Tâches dûes pour cette semaine',
  tasksDueForToday: 'Tâches dûes pour aujourd\'hui',
  taskUpdated: 'Tâche mise à jour',
  taskUpdatedFields: 'Mise à jour : {{fields}}',
  timeLogged: 'Temps enregistré',
  xSelectedTasks_one: '{{count}} tâche sélectionnée',
  xSelectedTasks_other: '{{count}} tâches sélectionnées',
  youHaveNoOverdueTasks: 'Vous n\'avez aucune tâche en retard.',
  youHaveTooMuchToDo: 'Vous avez une moyenne de {{avgHours}} heures par jour à compléter avant le {{date}}.',
  youHaveTooMuchToDoNext7Days: 'Vous avez une moyenne de {{avgHours}} heures par jour à compléter dans les 7 prochains jours.',
  youHaveTooMuchToDoToday: 'Vous avez {{avgHours}} heures à compléter avant la fin de la journée.',
  youHaveXOverdueTasks_one: 'Vous avez {{count}} tâche en retard.',
  youHaveXOverdueTasks_other: 'Vous avez {{count}} tâches en retard.',
  youHaveXTasksWithNoDueDate_one: 'Vous avez {{count}} tâche sans date d\'échéance.',
  youHaveXTasksWithNoDueDate_other: 'Vous avez {{count}} tâches sans date d\'échéance.',
};

export default tasks;
